import {SmallProductTypeFragment, ProductTypeType as GraphQLProductTypeType} from "../../../generated/graphql";
import {assertNever} from "../../utils/utils";

export interface SmallProductType {
  id: string
  type: ProductTypeType
  key: string
  translations?: ProductTypeTranslations
  doorRangePanelColumnCount?: number
  icon?: {
    svg: string
  }
}

export enum ProductTypeType {
  PRODUCT_TYPE = 'productType',
  DOOR_TYPE = 'doorType'
}

export type ProductTypeTranslations = {
  [key: string]: string
}


export function transformStringToProductTypeTranslations(translations?: string | null): ProductTypeTranslations | undefined {
  if (!translations) {
    return undefined;
  }
  try {
    return JSON.parse(translations);
  } catch (e) {
    console.error('Failed to parse translations', e);
    return undefined;
  }
}

export function mapSmallGraphQLProductTypeToSmallProductType(gql: SmallProductTypeFragment): SmallProductType {
  return {
    id: gql.id,
    key: gql.key,
    type: mapGraphQLProductTypeTypeToProductTypeType(gql.type),
    translations: transformStringToProductTypeTranslations(gql.translations),
    doorRangePanelColumnCount: gql.doorRangePanelColumnCount || undefined,
    icon: gql.icon ? {
      svg: gql.icon.svg,
    } : undefined,
  };
}

export function mapGraphQLProductTypeTypeToProductTypeType(type: GraphQLProductTypeType): ProductTypeType {
  switch (type) {
    case GraphQLProductTypeType.ProductType:
      return ProductTypeType.PRODUCT_TYPE;
    case GraphQLProductTypeType.DoorType:
      return ProductTypeType.DOOR_TYPE;
    default:
      return assertNever(type);
  }
}

export function mapProductTypeTypeToGraphQLProductTypeType(type?: ProductTypeType): GraphQLProductTypeType | undefined {
  if (!type) {
    return undefined;
  }
  switch (type) {
    case ProductTypeType.PRODUCT_TYPE:
      return GraphQLProductTypeType.ProductType;
    case ProductTypeType.DOOR_TYPE:
      return GraphQLProductTypeType.DoorType;
    default:
      return assertNever(type);
  }
}
